import { Column, Footer } from "./types";

export function fillColumnProps(column: Column | undefined | false | null, key: number = 0) {
    return { key, align: "left", show: true, width: "default", ...column } as Required<Column>;
}

export function fillFooterProps(footer: Footer | undefined | false | null, key: number = 0) {
    return { key, align: "left", from: undefined, span: 1, ...footer } as Required<Footer>;
}

export function columns(columns: (Column | undefined | false | null)[]) {
    return columns.map(fillColumnProps);
}

export function footers(footers: (Footer | undefined | false | null)[]) {
    return footers.map(fillFooterProps);
}